module.exports = __webpack_public_path__ + "media/assets_v3/images/auction-list-1-0227c852cd4efb03543a54e14397f8cf.png";